// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1JGbM","legacyBtn":"MutateMid_legacyBtn__1OtKs"};